import React, { useMemo, useState } from "react";
import {
  ArtDescriptionContainer,
  ArtImage,
  ContentContainer,
  CreatePasswordContainer,
  ImageContainer,
  MainContainer,
  SubtitleContainer,
} from "./styles";
import Art1 from "../../assets/png/artBackground/art1.png";
import Art2 from "../../assets/png/artBackground/art2.png";
import Art3 from "../../assets/png/artBackground/art3.png";
import Art4 from "../../assets/png/artBackground/art4.png";
import Art5 from "../../assets/png/artBackground/art5.png";
import Typography from "../../components/Typography";
import TextInput from "../../components/TextInput";
import Button from "../../components/Button";
import { authService } from "../../services/modules/auth";
import { Form } from "./types";
import { useNavigate } from "react-router-dom";
import { Avatar, notification } from "antd";
import { Row } from "../../themes/globalStyle";
import ThemeColors from "../../themes/colors";

const initialValues: Form = {
  email: "",
  password: "",
  confirm_password: "",
  friendly_name: "",
  avatar: Math.random().toString(),
};

const SignUp: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  const [form, setForm] = useState<Form>(initialValues);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getRandomImage = () => {
    const images = [
      {
        image: Art1,
        author: "Vincent van Gogh (1890)",
        title: "Green Wheat Fields, Auvers",
      },
      {
        image: Art2,
        author: "Henri-Edmond Cross (1898)",
        title: "Les Champs-Elysées",
      },
      {
        image: Art3,
        author: "Vincent van Gogh (1889 - 1889)",
        title: "Sunflowers",
      },
      { image: Art4, author: "Lee Seahyun (2008)", title: "Between Red_044" },
      {
        image: Art5,
        author: "James Turrell",
        title: "The Light Inside (Supplemental)",
      },
    ];

    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  };

  const imageInfo = useMemo(() => getRandomImage(), []);

  const handleLogin = () => {
    setIsLoading(true);

    authService
      .signUp(form)
      .then(() => {
        notification.success({
          message: "Sucesso!",
          description: "Conta criada com sucesso.",
        });
        navigate("/");
      })
      .finally(() => setIsLoading(false));
  };

  const getNewAvatar = () => {
    setForm((prev) => ({ ...prev, avatar: Math.random().toString() }));
  };

  return (
    <MainContainer>
      <ContentContainer>
        <Typography text="Seja um dos primeiros!" size="extraHuge" />
        <SubtitleContainer>
          <Typography
            text="Crie a sua conta para acessar com prioridade nossa plataforma e novas funcionalidades."
            size="large"
            color="Black400"
            weight={400}
          />
        </SubtitleContainer>
        <Row>
          <div style={{ width: 56, height: 56 }}>
            <Avatar
              src={`https://api.dicebear.com/7.x/miniavs/svg?seed=${form.avatar}`}
              size={56}
              style={{ background: ThemeColors.Purple100 }}
            />
          </div>
          <Button
            size="middle"
            borderRadius="0.5rem"
            style={{ width: "fit-content" }}
            backgroundColor={ThemeColors.Black500}
            onClick={getNewAvatar}
          >
            <Typography
              text="Gerar novo avatar"
              size="tiny"
              color="Bg300"
              weight={400}
            />
          </Button>
        </Row>
        <TextInput
          placeholder="Seu primeiro nome"
          onChange={(e) =>
            setForm((prev) => ({ ...prev, friendly_name: e.target.value }))
          }
        />
        <TextInput
          placeholder="Seu melhor e-mail"
          onChange={(e) =>
            setForm((prev) => ({ ...prev, email: e.target.value }))
          }
        />
        <TextInput
          placeholder="Digite uma senha forte"
          type="password"
          onChange={(e) =>
            setForm((prev) => ({ ...prev, password: e.target.value }))
          }
        />
        <TextInput
          placeholder="Repita sua senha"
          type="password"
          onChange={(e) =>
            setForm((prev) => ({ ...prev, confirm_password: e.target.value }))
          }
        />

        <Button onClick={handleLogin} loading={isLoading}>
          Criar minha conta
        </Button>
        <CreatePasswordContainer>
          <Typography
            text="Ao criar sua conta você declara ter lido e aceito os Termos e Condições da CoProdux"
            size="medium"
            color="Black200"
            weight={400}
          />
        </CreatePasswordContainer>
        <CreatePasswordContainer onClick={() => navigate("/")}>
          <Typography
            text="Já tenho uma conta"
            size="medium"
            color="Blue300"
            weight={400}
          />
        </CreatePasswordContainer>
      </ContentContainer>
      <ImageContainer>
        <ArtImage src={imageInfo.image} />
        <ArtDescriptionContainer>
          <Typography
            text="Inspire-se com"
            size="medium"
            color="Black100"
            weight={400}
          />
          <Typography
            text={imageInfo.title}
            size="medium"
            color="Black100"
            weight={600}
          />
          <Typography
            text={`- ${imageInfo.author}`}
            size="medium"
            color="Black100"
            weight={400}
          />
        </ArtDescriptionContainer>
      </ImageContainer>
    </MainContainer>
  );
};

export default SignUp;
